/* eslint-disable */
import { protoLib as lib } from '@tock/coretypes';

import protoDefs from '@tock/protos/dist/core.json';
import clowncarDefs from '@tock/protos/dist/clowncar.json';
import consumerDefs from '@tock/protos/dist/consumer.json';
import dashboardDefs from '@tock/protos/dist/dashboard.json';
import messagingDefs from '@tock/protos/dist/messaging.json';

lib.define('tocktix.messages').addJSON(protoDefs.nested.tocktix.nested.messages.nested);
lib
  .define('tocktix.proto.dashboard')
  .addJSON(dashboardDefs.nested.tocktix.nested.proto.nested.dashboard.nested);
lib
  .define('tocktix.proto.clowncar')
  .addJSON(clowncarDefs.nested.tocktix.nested.proto.nested.clowncar.nested);
lib
  .define('tocktix.proto.consumer')
  .addJSON(consumerDefs.nested.tocktix.nested.proto.nested.consumer.nested);
lib.define('tocktix.proto.messaging').addJSON(messagingDefs.nested.tocktix.nested.messaging.nested);
const resolvedRoot = lib.resolveAll();
export default {
  ...resolvedRoot.lookup('tocktix.proto.clowncar'),
  ...resolvedRoot.lookup('tocktix.proto.consumer'),
  ...resolvedRoot.lookup('tocktix.proto.dashboard'),
  ...resolvedRoot.lookup('tocktix.proto.messaging'),
  ...resolvedRoot.lookup('tocktix.messages'),
} as any;
